import React from "react";
import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <section className="max-w-2xl mx-auto px-6 py-32 text-center">
      <h1 className="font-serif text-5xl">No gift made.</h1>
      <p className="text-ink-soft mt-4">The checkout was cancelled. You're welcome back whenever the moment feels right.</p>
      <Link to="/donate" data-testid="cancel-retry" className="pill pill-primary mt-10 inline-flex">Try again</Link>
    </section>
  );
}
